import { MSG_ERROR, MSG_HIDE, MSG_INFO, MSG_SUCCESS } from "./MasgTypes";

export function ShowInfo(message: string) {
    return {
        type: MSG_INFO,
        payload: { message: message, severity: "info", open:true}
    }
}

export function ShowSuccess(message: string) {
    return {
        type: MSG_SUCCESS,
        payload: { message: message, severity: "success", open:true }
    }

}
export function ShowWarring(message: string) {
    return {
        type: MSG_SUCCESS,
        payload: { message: message, severity: "warning", open:true }
    }
}

export function ShowError(message: string, duration?:number) {
    return {
        type: MSG_ERROR,
        payload: { message: message, severity: "error", open:true, duration:duration }
    }
}

export function HideAlert() {
    return {
        type: MSG_HIDE,
        payload: { message: "", severity: "info", open:false }
    }
}